import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import triggerAPI from "../services/triggerAPI";
import { commonError } from "../../src/helper/constant"
import { endpoints } from '../services/endpoints';
import {
    AUM_RESPONSE, AUM_RESPONSE_FAIL, GET_BALANCE_SHEET_RESPONSE, GET_BALANCE_SHEET_FAILED, GET_BANK_BOOK_RESPONSE, GET_BANK_BOOK_FAILED, PMS_MANAGEMENT_FEES_LEDGER_RESPONSE, PMS_MANAGEMENT_FEES_LEDGER_FAILED, GET_BROKER_LEDGER_RESPONSE, GET_BROKER_LEDGER_FAILED,
    GET_CLIENT_INFO_RESPONSE, GET_CLIENT_INFO_FAILED, GET_LEDGER_ACCOUNT_FAILED, GET_EXIT_LOAD_LEDGER_RESPONSE, GET_EXIT_LOAD_LEDGER_FAILED, GET_INCOME_EXPENSE_STATEMENT_RESPONSE, GET_INCOME_EXPENSE_STATEMENT_FAILED, PMS_MOVEMENT_OF_CORPUS_RESPONSE,
    PMS_MOVEMENT_OF_CORPUS_FAILED, GET_LEDGER_ACCOUNT_RESPONSE, PMS_PERFORMANCE_BASED_FEES_LEDGER_RESPONSE,
    PMS_PERFORMANCE_BASED_FEES_LEDGER_FAILED,
    PMS_PROFIT_LOSS_RESPONSE,
    PMS_SECURITIES_TRANSACTION_TAX_RESPONSE,
    PMS_TRANSACTION_STATEMENT_REPORT_RESPONSE,
    PMS_PROFIT_LOSS_FAILED, PMS_SECURITIES_TRANSACTION_TAX_FAILED, PMS_UP_FRONT_FEES_PAYABLE_LEDGER_RESPONSE,
    PMS_TRANSACTION_STATEMENT_REPORT_FAILED, PMS_UP_FRONT_FEES_PAYABLE_LEDGER_FAILED,
    PERFORMANCE_FEES_CALCULATION_FAILED, PERFORMANCE_FEES_CALCULATION_RESPONSE,
    GET_PMS_WELCOME_LETTER_FAILED, GET_PMS_WELCOME_LETTER_RESPONSE,
    GET_CUSTODIAN_FEES_LEDGER_FAILED, GET_CUSTODIAN_FEES_LEDGER_RESPONSE, MIS_REPORTS_RESPONSE, MIS_REPORTS_FAILED,
    GET_MIS_MONTH_RESPONSE, GET_MIS_MONTH_FAILED, ACC_PER_MERGER_REPORTS_FAILED, ACC_PER_MERGER_REPORTS_RESPONSE
    ,ONEPAGER_REPORTS_FAILED,
    ONEPAGER_REPORTS_RESPONSE,
    GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE_FAIL,
    GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE,
    CAGR_REPORT_RESPONSE,
    CAGR_REPORT_FAILED
} from '../redux/types/reports';
import { GET_MF_ACCOUNT_STATEMENT_INVESTOR_FAILED, GET_MF_ACCOUNT_STATEMENT_INVESTOR_RESPONSE } from '../redux/types/initApp';

let call = new triggerAPI();

export function* aum({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetAUM);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: AUM_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: AUM_RESPONSE_FAIL, payload: data })
        }
    } catch (e) {
        yield put({ type: AUM_RESPONSE_FAIL, payload: commonError })
    }
}

export function* getInvestmentDistributionStatement({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetInvestmentDistributionStatement);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data?.data?.pdfUrl;
            responsePayload.excelUrl = data?.data?.excelUrl;
            yield put({ type: GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE_FAIL, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE_FAIL, payload: commonError })
    }
}

export function* balanceSheet({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetBalanceSheet);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: GET_BALANCE_SHEET_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_BALANCE_SHEET_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_BALANCE_SHEET_FAILED, payload: commonError })
    }
}

export function* bankBook({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetBankBook);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: GET_BANK_BOOK_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_BANK_BOOK_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_BANK_BOOK_FAILED, payload: commonError })
    }
}

export function* pmsManagementFeesLedger({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.PMSManagementFeesLedger);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: PMS_MANAGEMENT_FEES_LEDGER_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: PMS_MANAGEMENT_FEES_LEDGER_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: PMS_MANAGEMENT_FEES_LEDGER_FAILED, payload: commonError })
    }
}

export function* GetMFAccountStatementInvestor({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.accountStatementInvApi);
        if (data.success) {
            let responseData = data.data;
            responsePayload.success = true;
            responsePayload.base64Binary = responseData.base64Binary;

            yield put({ type: GET_MF_ACCOUNT_STATEMENT_INVESTOR_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_MF_ACCOUNT_STATEMENT_INVESTOR_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_MF_ACCOUNT_STATEMENT_INVESTOR_FAILED, payload: commonError })
    }
}
export function* brokerLedger({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetBrokerLedger);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: GET_BROKER_LEDGER_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_BROKER_LEDGER_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_BROKER_LEDGER_FAILED, payload: commonError })
    }
}

export function* clientInformation({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetClientInfo);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: GET_CLIENT_INFO_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_CLIENT_INFO_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_CLIENT_INFO_FAILED, payload: commonError })
    }
}

export function* getLedgerAccount({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetLedgerAccount);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: GET_LEDGER_ACCOUNT_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_LEDGER_ACCOUNT_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_LEDGER_ACCOUNT_FAILED, payload: commonError })
    }
}

export function* getExitLoadLedger({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetExitLoadLedger);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: GET_EXIT_LOAD_LEDGER_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_EXIT_LOAD_LEDGER_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_EXIT_LOAD_LEDGER_FAILED, payload: commonError })
    }
}

export function* getIncomeExpenseStatment({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetIncomeExpenseStatment);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: GET_INCOME_EXPENSE_STATEMENT_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_INCOME_EXPENSE_STATEMENT_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_INCOME_EXPENSE_STATEMENT_FAILED, payload: commonError })
    }
}

export function* pmsMovementOfCorpus({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.PMSMovementOfCorpus);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: PMS_MOVEMENT_OF_CORPUS_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: PMS_MOVEMENT_OF_CORPUS_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: PMS_MOVEMENT_OF_CORPUS_FAILED, payload: commonError })
    }
}

export function* pmsPerformanceBasedFeesLedger({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.PMSPerformanceBasedFeesLedger);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: PMS_PERFORMANCE_BASED_FEES_LEDGER_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: PMS_PERFORMANCE_BASED_FEES_LEDGER_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: PMS_PERFORMANCE_BASED_FEES_LEDGER_FAILED, payload: commonError })
    }
}

export function* pmsProfitLoss({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.PMSProfitLoss);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: PMS_PROFIT_LOSS_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: PMS_PROFIT_LOSS_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: PMS_PROFIT_LOSS_FAILED, payload: commonError })
    }
}

export function* pmsSecuritiesTransactionTax({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.PMSSecuritiesTransactionTax);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: PMS_SECURITIES_TRANSACTION_TAX_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: PMS_SECURITIES_TRANSACTION_TAX_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: PMS_SECURITIES_TRANSACTION_TAX_FAILED, payload: commonError })
    }
}

export function* pmsTransactionStatementReport({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.PMSTransactionStatementReport);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: PMS_TRANSACTION_STATEMENT_REPORT_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: PMS_TRANSACTION_STATEMENT_REPORT_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: PMS_TRANSACTION_STATEMENT_REPORT_FAILED, payload: commonError })
    }
}

export function* pmsUpfrontFeesPayableLedger({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.PMSUpfrontFeesPayableLedger);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: PMS_UP_FRONT_FEES_PAYABLE_LEDGER_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: PMS_UP_FRONT_FEES_PAYABLE_LEDGER_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: PMS_UP_FRONT_FEES_PAYABLE_LEDGER_FAILED, payload: commonError })
    }
}

export function* getPerformanceFeesCalculation({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetPerformanceFeesCalculation);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: PERFORMANCE_FEES_CALCULATION_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: PERFORMANCE_FEES_CALCULATION_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: PERFORMANCE_FEES_CALCULATION_FAILED, payload: commonError })
    }
}


export function* getPMSWelcomeLetter({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetPMSWelcomeLetter);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: GET_PMS_WELCOME_LETTER_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_PMS_WELCOME_LETTER_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_PMS_WELCOME_LETTER_FAILED, payload: commonError })
    }
}

export function* getCustodianFeesLedger({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetCustodianFeesLedger);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: GET_CUSTODIAN_FEES_LEDGER_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_CUSTODIAN_FEES_LEDGER_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_CUSTODIAN_FEES_LEDGER_FAILED, payload: commonError })
    }
}

export function* misMonth({ payload, resolve }) {

    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetMISMonth);
        if (data.success) {

            yield put({ type: GET_MIS_MONTH_RESPONSE, payload: data })
            resolve && resolve(data)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_MIS_MONTH_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_MIS_MONTH_FAILED, payload: commonError })
    }
}

export function* misReports({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.MISReport);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.misReport_Path;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: MIS_REPORTS_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: MIS_REPORTS_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: MIS_REPORTS_FAILED, payload: commonError })
    }

}

export function* accountPerMerger({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetAccountPerMerger);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: ACC_PER_MERGER_REPORTS_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: ACC_PER_MERGER_REPORTS_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: ACC_PER_MERGER_REPORTS_FAILED, payload: commonError })
    }

}

export function* onePager({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetOnePager);
        if (data.success) {
            responsePayload.success = true;
            responsePayload.pdfUrl = data.data.pdfUrl;
            responsePayload.excelUrl = data.data.excelUrl;
            yield put({ type: ONEPAGER_REPORTS_RESPONSE, payload: data.data })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: ONEPAGER_REPORTS_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: ONEPAGER_REPORTS_FAILED, payload: commonError })
    }

}

export function* cagrReport({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.GetCAGRReport);
        if (data?.data?.success) {
            let responseData = data?.data?.data;
            responsePayload.success = true;
            responsePayload.pdfUrl = responseData?.fileName;
            responsePayload.fileName = responseData?.fileName;
            responsePayload.base64Binary = responseData?.base64Binary;

            yield put({ type: CAGR_REPORT_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: CAGR_REPORT_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: CAGR_REPORT_FAILED, payload: commonError })
    }
}


